/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { MainPageEvent, useMainPageDataSelector } from ".";
import HmsInput, { ValidationProps } from "../Common/element/HmsInput";
import Modal from "react-bootstrap/Modal";

const reg = /^\d{6}$/;

const validation: ValidationProps = {
  regExVal: reg,
  regexErrorMsg: "Please enter the correct OTP code to proceed",
};

export default function VerifyOTPModal() {
  const [OTP, setOTP] = useState<string>("");
  const [validity, setValidity] = useState<boolean>(false);

  const dispatch = useDispatch();
  const mainPageData = useMainPageDataSelector();

  const submitOtp = () => {
    if (validity) {
      dispatch({
        type: MainPageEvent.OTP_VERIFY,
        payload: {
          otp: OTP,
          requestId: sessionStorage.getItem("otpRequestId"),
          requestCorrelator: sessionStorage.getItem("requestCorrelator"),
        },
      });
      setOTP("");
    }
  };

  return (
    <Modal
      show={mainPageData.showVerifyOTPModal}
      onHide={() => {
        dispatch({
          type: MainPageEvent.HIDE_VERIFY_OTP_MODAL,
        });
      }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Verify OTP</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please enter OTP code</p>
        <HmsInput
          inputType="text"
          className="form-control bg-back border-0"
          placeHolder="Enter your OTP here."
          value={OTP}
          validProps={validation}
          handleChange={setOTP}
          setValidity={setValidity}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-light"
          data-dismiss="modal"
          onClick={() => {
            dispatch({
              type: MainPageEvent.HIDE_VERIFY_OTP_MODAL,
            });
          }}
        >
          Close
        </button>
        <button
          className="btn btn-primary"
          type="button"
          onClick={() => {
            if (!mainPageData.signingIn) {
              submitOtp();
            }
          }}
        >
          <i
            className={
              mainPageData.signingIn ? "fas fa-spin fa-circle-notch" : ""
            }
          ></i>
          {mainPageData.signingIn ? " Submitting..." : " Submit"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
